import DynamicPage from 'util/hoc/dynamic-page';
const LoadServiceProviderSource = async () => {
  return await import(/* webpackChunkName: "admin/service-provider-source" */ 'apps/admin/pages/service-provider-source');
};

export default DynamicPage(LoadServiceProviderSource);
